import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!user) {
    return <Navigate to="/blog" replace />;
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/blog" replace />;
  }

  return children;
}

export default ProtectedRoute; 